import { SelectListItem } from '../lib/select/select-property';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { Router } from '@angular/router';
import * as t from '../lib/select/select-service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { BaseeSearchClass } from 'projects/Shared-Lib/model/search-result';

const ControllerName: string = 'ResourceActions';

//search filter request api fields
export class SearchClass extends BaseeSearchClass {
    ResourceName?: string;
    IsEnabled?: string;
}

export class Resource {
    //[Key] - Guid
    ResourceID?: string;
    ResourceName?: string;
    IsEnabled?: boolean;
    ActionNameList?: ActionNames[];
    constructor() {
    }
}

export class ActionNames {
    ActionName?: string;
    constructor(ActionName: string) {
        this.ActionName = ActionName;
    }
}

/** Resource Search class */
export class Resource_Search {
    filter: SearchClass;
    ddlEnabled?: SelectListItem[];
    SelectedEnabled?: SelectListItem;
    ddlResource?: SelectListItem[];
    SelectedResource?: SelectListItem;

    CurrentUser: any;
    // private dataService: DataService;
    constructor() {
        this.filter = new SearchClass();
        this.filter.ResourceName = '';
        this.filter.IsEnabled = '';

        this.ddlEnabled = t.GetItems(t.Items.Options_Enabled, true);
    }
}

export class Resource_Document extends Resource {
    ddlEnabled?: SelectListItem[];
    SelectEnabled?: any;

    constructor(private _dlgService: DialogService, private router: Router, private dataService: DataService) {
        super();
        this.ddlEnabled = t.GetItems(t.Items.Options_Enabled);
    }

    GetDocument(uid: string) {
        this.dataService.getData(`${ControllerName}/${uid}`, null, (ret) => {
            this.ResourceID = ret.Resource.ResourceID;
            this.ResourceName = ret.Resource.ResourceName;
            this.IsEnabled = ret.Resource.IsEnabled;
            this.SelectEnabled = ret.Resource.IsEnabled ? 1 : 0;
            ret.Actions.forEach(it => {
                this.ActionNameList.push(new ActionNames(it.ActionName));
            });
        });
    }
}
